"use client";

import { useLayoutEffect, useState } from "react";

export function useBreakpoint(breakpoint: string) {
  // Set null initially (Server Side Rendering)
  const [isBreakpoint, setIsBreakpoint] = useState<boolean | null>(null);

  useLayoutEffect(() => {
    const mediaQuery = window.matchMedia(`(min-width: ${breakpoint})`);
    const handleBreakpointChange = () => setIsBreakpoint(mediaQuery.matches);

    handleBreakpointChange();
    mediaQuery.addEventListener("change", handleBreakpointChange);
    return () => mediaQuery.removeEventListener("change", handleBreakpointChange);
  }, [breakpoint]);

  return isBreakpoint;
}
